export default __webpack_public_path__ + "static/media/background-fair.3b4174a6.svg";